<template>
    <div class="position-relative">
        <div
            @click.stop="this.emitter.emit('toggleBasketPopover');"
            class="cursor-pointer"
            :title="basketTitle"
        >
            <i class="fa-solid fa-basket-shopping fa-lg text-black"></i>
            <div v-if="updatedBasket.total_quantity > 0"
                class="basket-count bg-red rounded-5 position-absolute fw-bold"
            >
                <span>{{ updatedBasket.total_quantity }}</span>
            </div>
        </div>
        <NewBasketPopover
            :basket="updatedBasket"
        ></NewBasketPopover>
    </div>
</template>

<script>
    import NewBasketPopover from '@frontendAssets/js/components/Basket/NewBasketPopover.vue';

    export default {
        props: ['basket', 'icon'],
        components: { NewBasketPopover },
        data() {
            return {
                updatedBasket: this.basket
            }
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        computed: {
            basketTitle() {
                if(this.updatedBasket?.products?.length > 0) {
                    return this.updatedBasket.products.length + ' item' + (this.updatedBasket.products.length == 1 ? '' : 's') + ' in basket';
                }
                else {
                    return 'No items in basket';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .basket-count {
        right: -6px;
        top: -2px;
        height: 18px;
        span {
            position: absolute;
            top: 0;
            left: 6px;
        }
    }
</style>